import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import { RootState } from "@/store";
import { Toast } from "vant";
import { FORMAT_DATE_SMALL, isFinish } from "@/utils/common/date";
import { isBegin } from "@/utils/common/date";
import { handlePaginationData, queryRequest } from "@/utils/request";
import {
  queryK2PriceActivity,
  queryK2ActivitySku,
  searchK2ActivitySku,
  searchTbrActivity,
  searchTbrActivityProduct
} from "@/graphql/promotion.gql";
import { skuIsExpress } from "@/graphql/product.gql";
export interface IActivityDetailState {
  promotion: any;
  promotionProducts: any[];
  activityCode: string;
  skuExpressMap;
}
import { getAttributes, getAttrName } from "@/utils/mall/mall";

@Module({ name: "ActivityDetailModule", namespaced: true })
export default class ActivityDetailModule
  extends VuexModule<IActivityDetailState, RootState>
  implements IActivityDetailState {
  // 活动
  public promotion = {};
  // 活动商品
  public promotionProducts = [];
  // 活动编号
  public activityCode: string = "";
  // 添加购物车途中
  public addingCart: boolean = false;
  // sku是否支持快递映射表
  skuExpressMap: any = {};

  @Mutation
  clearSkuExpressMapMutation() {
    this.skuExpressMap = {};
  }
  @Mutation
  saveSkuExpressMapMutation(data = {}) {
    this.skuExpressMap = Object.assign({}, this.skuExpressMap, data);
  }
  @Mutation
  saveAddingCartMutation(data: boolean) {
    this.addingCart = data || false;
  }

  @Mutation
  saveActivityCodeMutation(data: string = "") {
    this.activityCode = data || "";
  }

  @Mutation
  savePromotionMutation(data = {}) {
    this.promotion = data;
  }
  @Mutation
  savePromotionProductsMutation(data = []) {
    this.promotionProducts = data || [];
  }

  // 清空页面数据
  @Action
  clearPageCacheDataAction() {
    const { commit } = this.context;
    commit("savePromotionMutation");
    commit("savePromotionProductsMutation");
    commit("saveActivityCodeMutation");
  }

  // 查询页面数据
  @Action
  async initDataAction() {
    const { state, commit } = this.context;
    const { data } = await queryRequest(
      {
        query: searchTbrActivity,
        variables: {
          activityCode: state.activityCode
        }
      },
      { custom: true }
    );

    console.log(185, data);
    commit("savePromotionMutation", data);
  }

  @Action
  async queryActivitySkuAction() {
    const { state, commit, dispatch } = this.context;
    const data = await queryRequest({
      query: searchTbrActivityProduct,
      variables: { activityCode: state.activityCode }
    });
    console.log(99, data);
    commit("savePromotionProductsMutation", data);
  }

  // 验证活动是否开始
  @Action
  verifyBeginAction() {
    const {
      state: { promotion }
    } = this.context;
    if (!isBegin(promotion.countDownStart, FORMAT_DATE_SMALL)) {
      Toast("活动还未开始，请耐心等待");
      return false;
    }
    if (isFinish(promotion.countDownEnd, FORMAT_DATE_SMALL)) {
      Toast("活动已结束，感谢参与");
      return false;
    }
    return true;
  }
}
